import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import JournalViewer from '../../../../DaEditorWrapper/Viewer/Journal';
import TextRenderer from '../../../../TextRenderer';
import { MatureDeviationContext } from '../../../../Context/MatureDeviationContext';
var TextContent = function (_a) {
    var textContent = _a.textContent, className = _a.className, deviationId = _a.deviationId, disableStylesForLegacy = _a.disableStylesForLegacy;
    var t = useTranslation().t;
    var showBlocked = useContext(MatureDeviationContext).showBlocked;
    return showBlocked ? (React.createElement("div", { className: className }, t('deviation.details.hiddenContent'))) : (React.createElement(TextRenderer, { className: className, textContent: textContent, reactViewer: JournalViewer, viewerKey: deviationId, legacyTheme: "journal", disableStylesForLegacy: disableStylesForLegacy }));
};
TextContent.displayName = 'TextContent';
export default TextContent;
//# sourceMappingURL=TextContent.js.map